import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import api from '../../services/api';

import Input from '../../components/Input';
import Loading from '../../components/Loading';

export default class PromoterResetConfirm extends Component {
  state = {
    alert: {},
    confirmPassword: '',
    loading: false,
    password: '',
    showAlert: false,
    token: null,
  };

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(this.props.location.search);
    const token = urlParams.get('token');
    if (!token) {
      this.props.history.push('/auth/promoter/reset_password');
    } else {
      this.setState({ token });
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { confirmPassword, password, token } = this.state;

    if (confirmPassword !== password) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Senha e confirmação de senha devem ser iguais.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    } else if (!confirmPassword || !password) {
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages: ['Senha e confirmação de senha são campos obrigatórios.'],
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    } else {
      this.setState({ loading: true });
      try {
        await api.put(`promoter_password_resets/${token}`, {
          promoter: {
            password,
          },
        });
        this.setState(
          {
            alert: {
              title: 'Senha alterada!',
              type: 'success',
              messages: ['Faça login pelo aplicativo com sua nova senha.'],
              onConfirm: () => this.props.history.push('/auth/promoter/reset_password'),
            },
          },
          () => {
            this.openAlert();
          },
        );
      } catch (err) {
        const messages = err.response && err.response.data && err.response.data.errors
          ? err.response.data.errors
          : ['Não foi possível completar a requisição. Por favor, atualize a página.'];
        this.setState(
          {
            alert: {
              title: 'Erro',
              type: 'danger',
              messages,
              onConfirm: () => this.closeAlert(),
            },
          },
          () => {
            this.openAlert();
          },
        );
      } finally {
        this.setState({ loading: false });
      }
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      confirmPassword,
      loading,
      password,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading && <Loading />}
        <div>
          <div className="row">
            <div className="col-12">
              <h2>Alterar senha</h2>
              <form onSubmit={this.handleSubmit}>
                <Input
                  name="password"
                  value={password}
                  type="password"
                  placeholder="Nova senha"
                  onChange={this.handleChange}
                />
                <Input
                  name="confirmPassword"
                  value={confirmPassword}
                  type="password"
                  placeholder="Confirmar nova senha"
                  onChange={this.handleChange}
                />
                <input
                  type="submit"
                  style={{ width: '100%' }}
                  className="btn btn-primary"
                  value="Alterar senha"
                />
              </form>
            </div>
          </div>
          {showAlert && (
            <SweetAlert
              type={type}
              confirmBtnText={confirmBtnText}
              confirmBtnBsStyle={confirmBtnBsStyle}
              showCancel={showCancel}
              cancelBtnText={cancelBtnText}
              cancelBtnBsStyle={cancelBtnBsStyle}
              title={title}
              onConfirm={onConfirm}
              onCancel={this.closeAlert}
            >
              <ul>
                {messages.map(msg => (
                  <li key={msg}>{msg}</li>
                ))}
              </ul>
            </SweetAlert>
          )}
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PromoterResetConfirm/index.js